import {Footer, Trial} from "../../components";
import React from "react";

export function CreateTrialPage() {
    return (
        <div>
            <Trial/>
            <Footer/>
        </div>
    )
}
